import React from "react";
import { Navigate } from "react-router-dom";

interface AuthValue {
  isAuthenticated: boolean;
  isLoading: boolean;
}

interface ProtectedRouteProps {
  children: React.ReactNode;
  auth: AuthValue;
}

const ProtectedRoute = ({ children, auth }: ProtectedRouteProps) => {
  const { isAuthenticated, isLoading } = auth;
  if (isLoading) return <div>Loading...</div>;
  if (!isAuthenticated) return <Navigate to="/login" />;

  return <>{children}</>;
};

export default ProtectedRoute;
